import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { Icon } from "../../lib/icon";
import { StaggerItem } from "../common/Reveal";

export default function IndustryCard({ industry }) {
  return (
    <StaggerItem>
      <Link
        to={`/industries/${industry.slug}`}
        className="group relative flex h-full flex-col overflow-hidden rounded-2xl border border-white/10 bg-ink-800/40 transition-colors duration-500 hover:border-sky-400/40"
        data-testid={`industry-card-${industry.slug}`}
      >
        <div className="relative h-44 overflow-hidden">
          <img
            src={industry.image}
            alt={industry.name}
            loading="lazy"
            className="h-full w-full object-cover opacity-70 transition-transform duration-700 group-hover:scale-105"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-ink-900 via-ink-900/40 to-transparent" />
          <div className="absolute left-4 top-4 inline-flex h-10 w-10 items-center justify-center rounded-lg border border-white/15 bg-ink-900/70 text-sky-400 backdrop-blur">
            <Icon name={industry.icon} className="h-5 w-5" />
          </div>
        </div>
        <div className="flex flex-1 flex-col p-6">
          <h3 className="font-heading text-lg font-bold tracking-tight text-white">
            {industry.name}
          </h3>
          <p className="mt-2 text-sm leading-relaxed text-slate-400">{industry.tagline}</p>

          <div className="mt-4 flex flex-wrap gap-1.5">
            {industry.technology.slice(0, 3).map((t) => (
              <span key={t} className="rounded-full border border-white/10 bg-white/5 px-2.5 py-1 text-[11px] text-slate-300">
                {t}
              </span>
            ))}
          </div>

          <div className="mt-6 inline-flex items-center gap-2 text-sm font-medium text-sky-400">
            Explore Industry
            <ArrowUpRight className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
          </div>
        </div>
      </Link>
    </StaggerItem>
  );
}
